export default __webpack_public_path__ + "static/media/amturn.9bb4bad8.webp";